// TODO: modificado por Ublux
import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  SYSTEM_BANNER_ENABLED: systemBannerEnabled,
  SYSTEM_BANNER_MESSAGE: systemBannerMessage,
  SYSTEM_BANNER_COLOR_SCHEME: systemBannerColorScheme,
  SYSTEM_BANNER_ACTION_URL: systemBannerActionUrl,
  SYSTEM_BANNER_ACTION_TEXT: systemBannerActionText,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(true),
  systemBannerEnabled: parseBoolean(systemBannerEnabled),
  systemBannerMessage: systemBannerMessage || '',
  systemBannerColorScheme: systemBannerColorScheme || 'warning',
  systemBannerActionUrl: systemBannerActionUrl || '',
  systemBannerActionText: systemBannerActionText || '',
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Ublux',
  isAChatwootInstance: $state => $state.installationName === 'Ublux',
};

export const actions = {};

export const mutations = {
  SET_SYSTEM_BANNER: ($state, payload) => {
    $state.systemBannerEnabled = parseBoolean(payload.enabled);
    $state.systemBannerMessage = payload.message || '';
    $state.systemBannerColorScheme = payload.colorScheme || 'warning';
    $state.systemBannerActionUrl = payload.actionUrl || '';
    $state.systemBannerActionText = payload.actionText || '';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
